import { signal } from '@angular/core';
import { type MatSelectChange } from '@angular/material/select';

import { COUNTRY_LIST, DEFAULT_COUNTRY } from '../models';

export abstract class PhoneNumberClass {
  phoneMask = signal(DEFAULT_COUNTRY.mask);
  phoneMaskExpression = signal(DEFAULT_COUNTRY.maskExpression);
  changeMaskSettings($event: MatSelectChange) {
    this.setMaskByCountryCode($event.value);
  }

  setMaskByCountryCode(countryCode: string | undefined) {
    const country = COUNTRY_LIST.find(country => country.code === countryCode);

    if (country?.mask && country.maskExpression) {
      this.phoneMask.set(country.mask);
      this.phoneMaskExpression.set(country.maskExpression);
    }
  }
}
